// extracted by mini-css-extract-plugin
export var disabled = "BlogListing-module--disabled--15c2a";
export var pagination = "BlogListing-module--pagination--30cff";
export var section = "BlogListing-module--section--b85b9";